export const reduxKey = '@@commissions';

//# sourceMappingURL=constants.js.map